import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { DocumentsList } from '../../Documents/components/documentsList';
import { fetchUser } from '../actions';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class UserDocumentsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const user = this.props.user;
    return (
      <Card className="user-info-card info-card data">
        <Container>
          <h2>{this.lbl('user.info.documents.title')}</h2>
          <DocumentsList entityId={user.id} entityType="user" items={user.documents}></DocumentsList>
        </Container>
      </Card>
    );
  }
}

UserDocumentsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const UserDocumentsCard = compose(
  withConnect,
  withRouter,
)(UserDocumentsCardComp);
